<style lang="sass">
@import ~bi/utilities
@import ~bi/brand/variables
@import ../../assets/sass/m3_variables
@import sass/footer
</style>

<template>
    <Zone
        :id="$json.footer.id"
        :dataLabel="$json.footer.dataLabel"
        contrast="dark"
        class="g_footer"
        autoHeight>
        <div class="g_row">
            <logo :coordonnees="true" />
            <div>
                <div
                    class="g_madeinfrance"
                    v-img-src="{ folder: 'logos', name: 'madeinfrance', ext: 'png', suffix: false }" />
                <Paragraph
                    :content="$json.footer.madeinfrance"
                    size="L" />
            </div>
        </div>
        <Paragraph
            :content="$json.footer.mentions"
            size="S" />
    </Zone>
</template>

<script>
import Logo from '../../components/Logo'

export default {
    name: 'Footer',
    components: {
        Logo
    }
}
</script>
